$(function() {

  //
  // Remove .no-js because javascript is enabled.

  $('html').removeClass('no-js');

  //
  // Parallax Background

  const backgroundImageParallax = ($object, multiplier = 0.5) => {
    // multiplier = typeof multiplier !== 'undefined' ? multiplier : 0.5;
    multiplier = 1 - multiplier;

    let $doc = $(document);

    $(window).scroll(function() {
      let from_top = $doc.scrollTop(),
      bg_css = '0 ' + (multiplier * from_top) + 'px';
      $object.css({ "background-position": bg_css });
    });
  };

  // Activate
  backgroundImageParallax($(".bg--top"), 1.075);
  backgroundImageParallax($(".bg--bottom"), 1.2);

  //
  // Logo Animation

  // Get path length
  const path = document.querySelector('.svg-logo-thumb .path');
  const pathLength = path.getTotalLength();

  // Set needed attributes.
  $('.svg-logo-thumb .path').attr({
    'stroke-dasharray': pathLength,
    'stroke-dashoffset': pathLength,
    'data-ready': 'true' // Only runs animation when this attribute exists
  });

  // 
  // Portfolio items
  
  $.getJSON("data.json", function(data) {

    let count = 1;

    $.each(data.items, function(i, data) {

      // Status Icon
      // - Changes based on status
      let statusIcon;

      switch (data.status) {
        case "live": {
          statusIcon = `<svg class="svg-live animate-in-viewport" width="21" height="17" viewBox="0 0 21 17" xmlns="http://www.w3.org/2000/svg" role="img"><title>status-live</title><g fill="#3F4" fill-rule="nonzero"><path d="M10.5,16.5 L6,10.5 C7.24,9.56 8.81,9 10.5,9 C12.19,9 13.76,9.56 15,10.5 L10.5,16.5 M10.5,14.84 L13.57,10.77 C12.65,10.28 11.61,10 10.5,10 C9.39,10 8.35,10.28 7.43,10.77 L10.5,14.84" id="path-base" /><path d="M10.5,6 C12.87,6 15.06,6.79 16.82,8.11 L16.22,8.91 C14.63,7.71 12.65,7 10.5,7 C8.35,7 6.37,7.71 4.78,8.91 L4.18,8.11 C5.94,6.79 8.13,6 10.5,6" id="path-3" fill="#ef0" /><path d="M10.5,3 C13.55,3 16.36,4 18.62,5.72 L18,6.5 C15.93,4.94 13.32,4 10.5,4 C7.68,4 5.07,4.94 3,6.5 L2.38,5.72 C4.64,4 7.45,3 10.5,3 Z" id="path-2" fill="#cf3" /><path d="M10.5,0 C14.23,0 17.67,1.24 20.43,3.32 L19.83,4.12 C17.23,2.16 14,1 10.5,1 C7,1 3.77,2.16 1.17,4.12 L0.57,3.32 C3.33,1.24 6.77,0 10.5,0" id="path-1" fill="#3F4" /></g></svg>`;
        } break;
        case "development": {
          statusIcon = `<svg class="svg-development animate-in-viewport a-spin" width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" role="img"><title>status-development</title><g fill-rule="nonzero" fill="none"><path class="inside" style="animation-delay: .25s" d="M17.59 12.5l-1.82-1.3c.3-1.08.32-2.25 0-3.42l1.82-1.28L16.14 4l-2.03.92c-.79-.8-1.79-1.42-2.96-1.71L10.95 1h-2.9l-.2 2.21c-1.17.29-2.17.91-2.96 1.71L2.86 4 1.41 6.5l1.82 1.28c-.32 1.17-.3 2.34 0 3.42l-1.82 1.3L2.86 15l2.03-.93c.79.79 1.79 1.39 2.96 1.7l.2 2.23h2.9l.2-2.23c1.17-.31 2.17-.91 2.96-1.7l2.03.93 1.45-2.5M11.5 0c.27 0 .5.2.5.46l.18 2.04c.76.28 1.44.69 2.05 1.18l1.85-.87c.23-.12.52-.04.66.19l2 3.5c.14.21.06.5-.16.65l-1.67 1.17c.13.8.12 1.59 0 2.36l1.67 1.17c.22.15.3.44.16.65l-2 3.5c-.14.21-.43.29-.66.17l-1.85-.86c-.61.49-1.29.89-2.05 1.19l-.18 2c0 .29-.23.5-.5.5h-4a.5.5 0 01-.5-.5l-.18-2c-.76-.3-1.44-.7-2.05-1.19l-1.85.86c-.23.12-.52.04-.66-.17l-2-3.5c-.14-.21-.06-.5.16-.65l1.67-1.17c-.12-.77-.13-1.56 0-2.36L.42 7.15C.2 7 .12 6.71.26 6.5l2-3.5c.14-.23.43-.31.66-.19l1.85.87c.61-.49 1.29-.9 2.05-1.18L7 .46C7 .2 7.23 0 7.5 0h4" fill="#FFB433"/><path class="outside" d="M12 10.382L11.438 10a1.796 1.796 0 000-1.006L12 8.618l-.448-.736-.627.27a1.966 1.966 0 00-.915-.502L9.948 7h-.896l-.062.65c-.361.085-.67.268-.915.503l-.627-.27L7 8.617l.562.376a1.796 1.796 0 000 1.006L7 10.382l.448.736.627-.274c.245.232.554.409.915.5l.062.656h.896l.062-.656c.361-.091.67-.268.915-.5l.627.274.448-.736M10.252 6c.101 0 .188.074.188.17l.068.751c.285.103.54.254.77.435l.696-.32a.191.191 0 01.248.07l.752 1.289c.052.077.022.184-.06.24l-.628.43c.049.295.045.586 0 .87l.628.43c.082.056.112.163.06.24l-.752 1.29a.197.197 0 01-.248.062l-.696-.316a2.97 2.97 0 01-.77.438l-.068.737a.184.184 0 01-.188.184H8.748a.186.186 0 01-.188-.184l-.068-.737a2.97 2.97 0 01-.77-.438l-.696.316a.197.197 0 01-.248-.062l-.752-1.29c-.052-.077-.022-.184.06-.24l.628-.43a2.699 2.699 0 010-.87l-.628-.43c-.082-.056-.112-.163-.06-.24l.752-1.29a.191.191 0 01.248-.07l.696.32c.23-.18.485-.33.77-.434l.068-.752c0-.095.087-.169.188-.169h1.504" fill="#F4FF33"/></g></svg>`;
        } break;
        case "concept": {
          statusIcon = `<svg class="svg-concept animate-in-viewport" width="17" height="24" viewBox="0 0 13 19" xmlns="http://www.w3.org/2000/svg" role="img"><title>status-concept</title><g fill="#A3F" fill-rule="nonzero"><path id="bulb" d="M9 17a2 2 0 01-2 2H6a2 2 0 01-2-2h1a1 1 0 001 1h1a1 1 0 001-1h1m1-3a2 2 0 01-2 2H5a2 2 0 01-2-2v-2c-1.8-1.18-3-3.2-3-5.5a6.5 6.5 0 0113 0c0 2.3-1.2 4.32-3 5.5v2m-6 0a1 1 0 001 1h3a1 1 0 001-1v-2.6c1.78-.9 3-2.76 3-4.9a5.5 5.5 0 00-11 0c0 2.14 1.22 4 3 4.9V14"/><path id="electric-1" class="electric" d="M3.13 7.12L5.5 4.75l2 2L9.25 5l.71.71L7.5 8.16l-2-2-1.66 1.67z"/></g></svg>`;
        } break;
        case "inactive": {
          statusIcon = `<svg class="svg-inactive animate-in-viewport" width="21" height="18" viewBox="0 0 21 18" xmlns="http://www.w3.org/2000/svg" role="img"><title>status-inactive</title><g fill-rule="nonzero" fill="none"><path d="M10.5 17.5l-4.5-6c1.24-.94 2.81-1.5 4.5-1.5s3.26.56 4.5 1.5l-4.5 6m0-1.66l3.07-4.07a6.5 6.5 0 00-6.14 0l3.07 4.07" fill="#FE3"/><path d="M16.82 9.11l-.6.8a9.472 9.472 0 00-1.677-1.012l.517-.858c.623.3 1.212.66 1.76 1.07z" fill-opacity=".8" fill="#E06952"/><path d="M10.5 7c1.275 0 2.498.229 3.63.645l-.524.872A9.511 9.511 0 0010.5 8c-2.15 0-4.13.71-5.72 1.91l-.6-.8C5.94 7.79 8.13 7 10.5 7z" fill="#E06952"/><path d="M18.71 6.246l-.521.85a12.44 12.44 0 00-7.085-1.632l-.337-.976c2.866-.258 5.61.397 7.942 1.758z" fill-opacity=".8" fill="#E06952"/><path d="M7.296 4.937l-.053 1.012c-1.235.109-2.433.401-3.553.853l-.397-.913a13.274 13.274 0 014.003-.952z" fill-opacity=".7" fill="#E06952"/><path d="M20.548 3.846l-.483.876a15.452 15.452 0 00-6.391-1.905l.053-.998c2.439.172 4.76.884 6.82 2.027z" fill-opacity=".5" fill="#E06952"/><path d="M2.834 3l.514.858c-.702.452-1.364.96-1.981 1.515L.7 4.63A16.545 16.545 0 012.834 3z" fill-opacity=".6" fill="#E06952"/><path d="M10.771.561l-.105 1.01-.276.02a15.502 15.502 0 00-4.367 1.03l-.521-.867A16.493 16.493 0 0110.772.56z" fill-opacity=".7" fill="#E06952"/></g></svg>`;
        } break;
      }

      // Status Label
      let statusLabel;

      switch (data.status) {
        case "live": {
          statusLabel = `Live`;
        } break;
        case "development": {
          statusLabel = `In Progress`;
        } break;
        case "concept": {
          statusLabel = `Concept`;
        } break;
        case "inactive": {
          statusLabel = `Inactive`;
        } break;
      }

      // Row Class
      // Alternate location of content per item.
      let rowClass = `row`;

      if (!isOdd(count)) {
        rowClass = `row flex-md-row-reverse`;
      }

      // Poster
      // - Take simple image url and update for srcset
      let posterOriginal = data.poster,
          posterStripped,
          posterSrcset;

      // Remove file extension
      posterStripped = posterOriginal.replace(/\.[^/.]+$/, "");

      // Create src for 2x resolution (not used)
      // posterSrc2x = posterStripped + '@2x.jpg';

      // Combine 1x and 2x
      // posterSrcset = posterStripped + '.jpg, ' + posterStripped + '@2x.jpg 2x';

      // Title
      // If link is available, provide, otherwise not.
      let title = '';

      if (data.link !== '') {
        title = `<h3 class="h2 piece-title mb-1"><a class="text-white" href="${data.link}" title="Visit ${data.title} in a new window." aria-label="Visit ${data.title} in a new window." target="_blank" rel="nofollow noopener">${data.title}</a></h3>`;
      } else {
        title = `<h3 class="h2 piece-title mb-1">${data.title}</h3>`;
      }
      
      // Link
      // Only show if available
      let pieceLink = '';

      if (data.link) {
        pieceLink = `<a class="piece-link d-inline-block ml-3" href="${data.link}" rel="nofollow noopener" target="_blank" title="Visit ${data.title} in a new window."><span class="svg svg-link mr-2" style="margin-top: -4px"><svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg" role="img"><title>link</title><g fill-rule="nonzero" fill="none"><path d="M2.08 16.92a4.49 4.49 0 010-6.36l1.63-1.63.15 1.26-1.08 1.08a3.513 3.513 0 000 4.95 3.513 3.513 0 004.95 0l3.54-3.54a3.513 3.513 0 000-4.95c-.3-.3-.64-.53-1-.7v.01a.488.488 0 01-.24-.67c.12-.25.41-.37.66-.24h.01c.46.21.89.51 1.27.9a4.49 4.49 0 010 6.36l-3.53 3.53a4.49 4.49 0 01-6.36 0z" fill="#0098CC"/><path d="M8.73 11.97c.27.11.36.41.24.66-.12.25-.41.37-.66.24H8.3c-.46-.21-.89-.51-1.27-.9a4.49 4.49 0 010-6.36l3.53-3.53a4.49 4.49 0 016.36 0 4.49 4.49 0 010 6.36l-1.63 1.63-.15-1.26 1.08-1.08a3.513 3.513 0 000-4.95 3.513 3.513 0 00-4.95 0L7.73 6.32a3.513 3.513 0 000 4.95c.3.3.64.53 1 .7" fill="#1AC4FF"/></g></svg></span>Visit</a>`;
      }
      
      // Portfolio Item Template
      const portfolioItems = 
      `<div id="piece-${count}" class="piece pt-3 pb-4 py-md-4 py-lg-5 py-xl-6">
        <div class="${rowClass}">
          <div class="col-md-6">
            <figure class="piece-poster mx-md-auto mb-4 mb-md-0">
              <a class="d-block" href="${posterStripped}-1000w.jpg" data-fancybox="gallery-${count}" data-caption="<h3>${data.title}</h3><p>${data.description}</p>">
                <picture>
                  <source data-srcset="${posterStripped}-320w.webp 320w, ${posterStripped}-500w.webp 500w, ${posterStripped}-640w.webp 640w, ${posterStripped}-960w.webp 960w, ${posterStripped}-1000w.webp 1000w" type="image/webp">
                  <source data-srcset="${posterStripped}-320w.jpg 320w, ${posterStripped}-500w.jpg 500w, ${posterStripped}-640w.jpg 640w, ${posterStripped}-960w.jpg 960w, ${posterStripped}-1000w.jpg 1000w" type="image/jpeg">
                  <img class="img-fluid animate blurIn lazy" src="${posterStripped}-320w.jpg" data-src="${posterStripped}-500w.jpg" data-sizes="(max-width: 1079px) 320px, 500w" width="500px" height="375px" alt="${data.title}">
                </picture>
              </a>
            </figure>
          </div>
          <div class="col-md-6 d-flex flex-column">
            <div class="piece-content my-auto">
              ${title}
              <p class="piece-subtitle mb-4 text-gray-300">${data.subtitle}</p>
              <div class="piece-description mb-3">${data.description}</div>
            </div>
            <div class="piece-actions d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-md-start">
              <div class="piece-date">${data.year}</div>
              <div class="piece-divider px-3" style="margin-top: -4px;"><span class="svg svg-divider"><svg width="11" height="18" viewBox="0 0 11 18" xmlns="http://www.w3.org/2000/svg" role="img"><title>divider</title><path d="M10 0h1L1 18H0z" fill="#61686B" fill-rule="evenodd"/></svg></span></div>
              <span class="piece-status">
                <span class="status-icon svg mr-1" style="margin-top: -3px;">${statusIcon}</span>
                <span class="status-label text-capitalize">${statusLabel}</span>
              </span>
              ${pieceLink}
            </div>
          </div>
        </div>
      </div>`;

      // Append to document.
      $('.section-portfolio').append(portfolioItems);

      // Gallery Media
      let galleryItemCount = 1;

      $.each(data.media, function(i, data) {
        let itemOriginal = data.src,
            itemStripped,
            itemSrcset;

        // Strip file extension
        itemStripped = itemOriginal.replace(/\.[^/.]+$/, "");

        // Create 2x src (not used)
        // itemSrc2x = itemStripped + '@2x.jpg';

        // Create 1x 2x srcset.
        itemSrcset = itemStripped + '.jpg, ' + itemStripped + '@2x.jpg 2x';

        $('<a />', {
          id: 'gallery-item-' + galleryItemCount,
          class: 'd-none',
          href: itemOriginal,
          'data-srcset': itemSrcset,
          'data-width': data.width,
          'data-height': data.height,
          'data-fancybox': 'gallery-' + count,
          'data-caption': data.caption
        }).appendTo('#piece-' + count);

        galleryItemCount++;
      });

      // Increase counter
      count++;
    });
  }).done(function (data) {

    // Activate Animations
    animations();
    viewportAnimations();

    // Activate Lazy Loading
    let lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazy"
      // ... more custom settings?
    });

    // Activate Fancybox
    activateFancybox();
  });

  //
  // Slideout Menu - Main
  // - Used for Mobile Navigation (Tap Menu)
  // - https://mango.github.io/slideout/

  let slideoutMobile = new Slideout({
    'panel': document.getElementById('panel-page'),
    'menu': document.getElementById('panel-mobile'),
    'duration': 0,
    'touch': false
    // 'padding': '100%',
    // 'tolerance': 70
  });

  // Button to trigger above slideout
  $('[data-toggle="slideout"]').on('click', function(e) {
    let targetPanel = $(this).data('target');

    // slideoutMobile.toggle();
    $('body').toggleClass('nav--is-open');

    $(targetPanel).toggleClass('is-open');

    // let targetElement = document.querySelector(targetPanel);
  });

});

// function add(a, b = 3) {
//   const total = a + b;
//   return total;
// }

// const add = (a, b = 3) => a + b;

// Check if number is Odd
const isOdd = num => num % 2;

// Viewport Animations
// - Show animation whenever in viewport.
const viewportAnimations = () => {
  let myAnimations = document.querySelectorAll('.animate-in-viewport');

  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        $(entry.target).addClass('in-viewport');
      } else {
        // $(entry.target).removeClass('in-viewport');
      }
    });
  });

  myAnimations.forEach(ele => {
    observer.observe(ele);
  });
}

// Animations
// - Run animation once.
const animations = () => {
  let myAnimations = document.querySelectorAll('.animate');

  observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.intersectionRatio > 0) {
        $(entry.target).addClass('in-viewport');
      }
    });
  });

  myAnimations.forEach(ele => {
    observer.observe(ele);
  });
}

// Fancybox
const activateFancybox = () => {
  $('[data-fancybox]').fancybox({
    infobar: false,
    buttons: ["zoom", "download", "close"],
    btnTpl: {
      zoom:
        '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}" aria-label="Zoom Image">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg>' +
        "</button>",
      download:
        '<a data-fancybox-download class="fancybox-button fancybox-button--download" title="Open Image in New Window" aria-label="Open Image in New Window" href="javascript:;" target="_blank">' +
        '<svg viewBox="0 0 24 24"><path d="M12,5 L12,7 L7,7 L7,17 L17,17 L17,12 L19,12 L19,17.4444444 C19,18.3035541 18.3035541,19 17.4444444,19 L17.4444444,19 L6.55555556,19 C5.69644594,19 5,18.3035541 5,17.4444444 L5,17.4444444 L5,6.55555556 C5,5.7 5.69222222,5 6.55555556,5 L6.55555556,5 L12,5 Z M19,5 L19,10.4444444 L17.4444444,10.4444444 L17.4444444,7.65222222 L9.79888889,15.2977778 L8.70222222,14.2011111 L16.3477778,6.55555556 L13.5555556,6.55555556 L13.5555556,5 L19,5 Z" /></svg>' +
        "</a>",
      close:
        '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg>' +
        "</button>",
  
      // Arrows
      arrowLeft:
        '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}" aria-label="Previous Image">' +
        '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div>' +
        "</button>",
  
      arrowRight:
        '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}" aria-label="Next Image">' +
        '<div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div>' +
        "</button>",
  
      // This small close button will be appended to your html/inline/ajax content by default,
      // if "smallBtn" option is not set to false
      smallBtn:
        '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}" aria-label="Close">' +
        '<svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg>' +
        "</button>"
    },
    preventCaptionOverlap: true,
    idleTime: false,
    gutter: 0,
    animationDuration: 300,
    transitionDuration: 300,
    afterLoad: (instance, slide) => {
      
      // Find height of caption and set as padding on all slides
      // - Fancybox has a bug that will show the previous slide's caption if the next is empty, causing the slide with the "empty" caption to not take it into account and having a display issue.
			$('.fancybox-slide').css('padding-bottom', $('.fancybox-caption').outerHeight());

    },
    afterClose: (instance, slide) => {

      // Ensure the gallery hash is removed from the address bar on close.
      // - Seems to sometimes stick around.
      location.hash = '';
    }
  });
}